@if (isCalendarSidepanel()) {
    <h2 class="filters-title s-mb-24"
        [innerHTML]="storeSvc.localeObj().tf_1_Calendar_rateCalender_filters_title"
    ></h2>
}

@if (!isCalendarSidepanel()) {
    <div class="filter-search px-2">
        <app-textbox [placeholder]="'Search'" [type]="'text'" [required]="false" [last]="true"
            (onChange)="handleSearch($event)" [icon]="'fa-solid fa-magnifying-glass'" />
    </div>
}

<div class="filter-items px-2"
    [class]="isCalendarSidepanel() ? 'd-flex flex-column gap-3 overflow-visible' : 'px-2'"
>
    @if (isCalendarSidepanel()) {
        <app-day-use-rooms
            [isCalendarSidepanel]="true"
            (selectionChanged)="dayUseRoomsSelectionChanged.emit($event)"
        />
    }

    @for (filter of filtersArray(); track filter.attributeName; let first = $first) {
        @if (isCalendarSidepanel()) {
            <app-form-dropdown
                [id]="filter.attributeName+'-dropdown'"
                [btnLabel]="filter.defaultAttribute ? getTranslatedDefRoomAttrName(filter) : filter.attributeName"
                [list]="filter.options"
                [multiSelect]="filter.selectionType === 'multiple'"
                [bindValue]="filter.selectedOptionIds"
                (selectionChange)="handleDropdownSelectionChanged(filter, $event)"
            />
        } @else {
            <div class="filter-item">
                <h5 class="filter-item-title" [class.first]="first">
                    {{ filter.defaultAttribute ? getTranslatedDefRoomAttrName(filter) : filter.attributeName }}
                </h5>
                <div class="filter-options d-flex">
                    @if (filter.selectionType === 'single') {
                    <app-radio [data]="filter.options" [rname]="filter.attributeName" [direction]="'column'"
                        (selectionChanged)="handleSelectionChanged($event, 'radio')" />
                    } @else if (filter.selectionType === 'multiple') {
                    <app-checkbox [data]="filter.options" [cname]="filter.attributeName" [direction]="'column'"
                        (selectionChanged)="handleSelectionChanged($event, 'checkbox')" />
                    }
                </div>
            </div>
        }
    }
</div>

@if (!isCalendarSidepanel()) {
    <div class="filter-footer mt-auto d-flex justify-content-between align-items-center" [class.s-pt-20]="isMobileLarge()">
        <app-button variant="link" [label]="storeSvc.localeObj()?.tf_2_RoomList_filters_resetFilters"
            (onClickEvent)="resetFilters()" />
        <app-button-group [options]="btnGroup" (onClickEvent)="handleBtnClick($event)" />
    </div>
}